<template>
  <main class="container alianca-content alianca-content-seuplano">
    <section class="row">
      <div class="main-content main-content-seuplano col-12">
        <transition name="fade">
          <div id="seu-plano">
            <div class="header-seu-plano header-assinar-proposta">
              <div class="container header-plano-content">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="backtoassinarproposta()"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px; justify-content: end;">
                  <h3 style="margin-left: 70px">Finalizar proposta</h3>
                </div>
                <b-row class="resumo-proposta main-header-assinar-proposta enviar-documentos-box" style="height: 88px; margin-top: 28px">
                  <b-col md="5" sm="12" class="subrow-header-assinar-proposta">
                    <b-row>
                      <img
                        src="../assets/protocolo.svg"
                        alt="Protocolo de atendimento"
                        style="margin-left: 37px; margin-right: 21px;"
                      />
                      <span style="margin-top: 4px"><b>Número da sua proposta:</b> {{ numProposta }}</span>
                    </b-row>
                  </b-col>
                  <b-col md="6" sm="12" class="border-left-assinatura enviar-documentos-btn">
                   <div style="display: inherit" @click="gotoend()">
                    <b-button class="btn-alianca btn-next btn-next btn-next-continuar-upload btn-clicked">ENVIAR DOCUMENTOS</b-button>
                    <b-button class="btn-alianca btn-next btn-icon-next btn-clicked-icon"><font-awesome-icon icon="angle-right" class="icon-arrow-right" /></b-button>
                   </div>
                  </b-col>
                </b-row>
              </div>

              <b-modal id="modal-enviar-documentos">
                <template #modal-header="{ close }">
                  <h5 class="title-modal">Digitalize seus documentos com seu smartphone</h5>
                  <b-button class="close btn-close" aria-label="Close" @click="close()">×</b-button>
                </template>
                <div class="modal-documentos-content">
                  <p class="modal-documentos-p">Baixe o aplicativo indicado abaixo, ou outro de sua preferência, e digitalize seus documentos pessoais de forma rápida e prática.</p>
                </div>
                <template #modal-footer="{ ok }">
                  <b-button class="btn-enviar-documento" @click="ok();">ENVIAR DOCUMENTOS</b-button>
                </template>
              </b-modal>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="assinar-proposta">
            <div class="content-assinar-proposta">
              <div class="container">
                <h3>Agora você precisa enviar os seus documentos</h3>
                <p style="margin-top: 24px">Para enviar os seus documentos, basta selecionar abaixo os campos e carregar uma cópia ou uma foto do RG, CPF, Comprovante de Residência e Cartão de Saúde. <b>Você pode fazer o envio do seu computador ou celular.</b></p>
              
                <div style="margin: 0; margin-top: 48px; margin-bottom: 100px">
                  <div v-for="(documento, i) in documentos" :key="i" class="rows-documentos">
                    <b-row class="resumo-proposta main-header-assinar-proposta item-upload">
                      <b-col md="3" sm="12" class="subrow-header-assinar-proposta" style="margin-top: -4px">
                        <span><b>{{ documento }}</b></span>
                        <span class="span-row-upload-mobile" style="display: none">Aceitamos arquivo em .pdf, .doc, .jpg, .png</span>
                      </b-col>
                      <b-col md="9" sm="12" class="border-left-upload">
                        <b-button class="filter-select btn-upload">
                          Clique aqui para fazer o upload
                          <img
                            src="../assets/upload.svg"
                            alt="Clique aqui para fazer o upload"
                          />
                        </b-button>
                        <span class="span-row-upload">Aceitamos arquivo em .pdf, .doc, .jpg, .png</span>
                      </b-col>
                    </b-row>
                  </div>

                  <div class="rows-documentos">
                    <b-row class="resumo-proposta main-header-assinar-proposta item-upload">
                      <b-col md="3" sm="12" class="subrow-header-assinar-proposta" style="margin-top: -4px">
                        <span><b>Documento X:</b></span>
                        <span class="span-row-upload-mobile" style="display: none">Aceitamos arquivo em .pdf, .doc, .jpg, .png</span>
                        <b-button class="filter-select btn-upload btn-upload-mobile" style="display: none">
                          <img
                            src="../assets/upload.svg"
                            alt="Clique aqui para fazer o upload"
                          />
                        </b-button>
                      </b-col>
                      <b-col md="9" sm="12" class="border-left-upload">
                        <span class="span-row-upload-success">
                          <img
                              src="../assets/nextstep.svg"
                              alt="Editar arquivo"
                              style="margin-top: 4px; margin-left: 18px; margin-right: 18px"
                            /> exemplo-documento.png
                        </span>
                        <b-button class="filter-select btn-upload btn-upload-edit btn-upload-second">
                          Editar arquivo
                          <img
                            src="../assets/upload.svg"
                            alt="Editar arquivo"
                          />
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>
    </section>
  </main>
</template>

<script>
import store from '@/store'
  export default {
    name: 'Assinar-proposta',
    components: {},
    data(){
      return {
        protocolo: 5215689968,
        documentos: [
          'Documento RG:',
          'Documento CPF:',
          'Comprovante de Residência:',
          'Cartão de Saúde:'
        ]
      }
    },
    computed: {
    numProposta(){
        return store.getters.getAliancaProposta != null ? store.getters.getAliancaProposta.num_proposta : 0
    },
    },
    methods: {
      formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
        try {
          decimalCount = Math.abs(decimalCount);
          decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

          const negativeSign = amount < 0 ? "-" : "";

          let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
          let j = (i.length > 3) ? i.length % 3 : 0;

          return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
          console.log(e)
        }
      },
      gotoend(){
        this.$router.push("adesao-finalizada")
      },
      backtoassinarproposta(){
        this.$router.push("assinar-proposta")
      },
    },
    mounted(){
      document.getElementById('step-progress').value = 100
      document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
      document.getElementById('step-progress-point4').classList.add("rounded-point-progress-ok")
      
      for (let i = 1; i <= 4; i++){
        document.getElementById('globaletapam' + i).classList.remove("etapas-progresso-mobile-show")
        document.getElementById('globaletapaprox' + i).classList.remove("div-proximo-etapa-mobile-show")
      }

      document.getElementById('globaletapam4').classList.add("etapas-progresso-mobile-show")
      document.getElementById('globaletapaprox4').classList.add("div-proximo-etapa-mobile-show")
    },
  }
</script>
